import { invalidateCacheRpc } from 'nav-client-types/NavConfigService-v5/operations';
import { rpcClient } from '../client';
export const clearNavigationCache = () => rpcClient.call(invalidateCacheRpc, {});